(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-blocks"] && !Shopify.designMode) return;
  try {
    
  /**
   * Init Chat Link.
   */
  const initChatLink = () => {
    const chatLink = document.querySelector('[data-chat-link]');

    if (!chatLink) {
      return;
    }

    chatLink.addEventListener('click', (event) => {
      event.preventDefault();
      window?.GorgiasChat?.open();
    })
  };

  initChatLink();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["images-feed"] && !Shopify.designMode) return;
  try {
    
  class ImagesFeed extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('.swiper')) return;

      this.options = {
        slidesPerView: 'auto',
        spaceBetween: 13,
        loop: true,
        breakpoints: {
          750: {
            spaceBetween: 31
          }
        }
      };
      this.slider = new Swiper(
        this.querySelector('.swiper'),
        this.options,
      );
    }
  }

  customElements.define('images-feed', ImagesFeed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-nav"]) return;
  try {
    
  class PageNav extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.links = Array.from(this.querySelectorAll('a[href^="#"]'));
      this.initObserver();
    }

    initObserver() {
      const options = {
        root: null,
        rootMargin: '-20% 0px -80% 0px',
        threshold: 0
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            this.updateActiveLink(`#${id}`);
          }
        });
      }, options);

      this.links.forEach(link => {
        const url = link.getAttribute('href');
        if (url && url.startsWith('#')) {
          const target = document.querySelector(url);
          if (target) {
            this.observer.observe(target);
          }
        }
      });
    }

    updateActiveLink(href) {
      this.links.forEach(link => {
        if (link.getAttribute('href') === href) {
          link.classList.add('is-active');
        } else {
          link.classList.remove('is-active');
        }
      });
      // Update URL hash without causing a page jump
      history.replaceState(null, null, href);
    }

  }

  customElements.define('page-nav', PageNav);

  } catch(e) { console.error(e); }
})();
})();
